const AboutSection = () => {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="relative">
              <div className="bg-gradient-to-br from-emerald-400 to-emerald-600 rounded-tl-3xl rounded-br-3xl h-64 md:h-96"></div>
              <div className="absolute top-4 left-4 right-4 bottom-4 md:top-8 md:left-8 md:right-8 md:bottom-8 bg-white/90 backdrop-blur-sm rounded-tr-3xl rounded-bl-3xl shadow-xl p-4 md:p-8 flex items-center justify-center">
                <div className="text-center">
                  <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-emerald-50 rounded-full mb-2 md:mb-4">
                    <img 
                      src="/logos/Adobe Express - file.png" 
                      alt="Advensify Logo" 
                      className="h-12 md:h-14 w-auto"
                    />
                  </div>
                  <h3 className="text-lg md:text-xl font-montserrat font-semibold mb-1 md:mb-2 text-emerald-700">Innovation Hub</h3>
                  <p className="text-sm md:text-base text-gray-600">Where cutting-edge technology meets business transformation</p>
                </div>
              </div>
            </div>
          </div>
          
          <div>
            <h2 className="text-2xl md:text-4xl font-bold mb-4 md:mb-6 font-montserrat">
              About <span className="gradient-text">Advensify</span>
            </h2>
            
            <p className="text-sm md:text-base text-gray-700 mb-4 md:mb-6">
              Founded in 2025, Advensify is a technology innovator with a passionate team dedicated to delivering enterprise-grade AI and software services. We combine deep technical expertise with industry knowledge to create solutions that drive real business value.
            </p>
            
            <div className="grid grid-cols-2 gap-3 md:gap-4 mb-6 md:mb-8">
              <div className="bg-white p-3 md:p-4 rounded-lg shadow-sm">
                <div className="text-emerald-500 font-bold text-xl md:text-2xl font-montserrat">10+</div>
                <div className="text-gray-600 text-xs md:text-sm">Team Members</div>
              </div>
              <div className="bg-white p-3 md:p-4 rounded-lg shadow-sm">
                <div className="text-emerald-500 font-bold text-xl md:text-2xl font-montserrat">15+</div>
                <div className="text-gray-600 text-xs md:text-sm">Technologies</div>
              </div>
              <div className="bg-white p-3 md:p-4 rounded-lg shadow-sm">
                <div className="text-emerald-500 font-bold text-xl md:text-2xl font-montserrat">100%</div>
                <div className="text-gray-600 text-xs md:text-sm">Client Satisfaction</div>
              </div>
              <div className="bg-white p-3 md:p-4 rounded-lg shadow-sm">
                <div className="text-emerald-500 font-bold text-xl md:text-2xl font-montserrat">24/7</div>
                <div className="text-gray-600 text-xs md:text-sm">Support</div>
              </div>
            </div>
            
            <p className="text-sm md:text-base text-gray-700">
              Our headquarters in Coimbatore, India serves as the center of our global operations, allowing us to deliver premium solutions to clients worldwide. We're committed to ethical AI development and sustainable digital transformation.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
